export class ValidaSenha {
    private static readonly MIN_LENGTH = 8;
    private static readonly CRITERIOS = [
        { 
            regex: new RegExp(`.{${ValidaSenha.MIN_LENGTH},}`), 
            mensagem: `Pelo menos ${ValidaSenha.MIN_LENGTH} caracteres` 
        },
        { 
            regex: /[A-Z]/, 
            mensagem: `uma letra maiúscula` 
        },
        { 
            regex: /[a-z]/, 
            mensagem: `uma letra minúscula` 
        },
        { 
            regex: /[0-9]/, 
            mensagem: `um número` 
        },
        { 
            regex: /[^a-zA-Z0-9_]/, 
            mensagem: `um caractere especial (ex: !, @, #, $, etc.)` 

        }
    ];

    public static validar(senha: string): boolean {
        return this.CRITERIOS.every(criterio => criterio.regex.test(senha));
    }

    public static obterRequisitosNaoAtendidos(senha: string): string {
        const erros = this.CRITERIOS
            .filter(criterio => !criterio.regex.test(senha))
            .map(criterio => criterio.mensagem);
        
        if (erros.length > 0) {
            return `A senha deve conter: ${erros.join(', ')}.`;
        }
        return '';
    }
}
